// add bottom padding if read more button exists
// $(function() {
//   if ($('.card-body').find('.btn-teaser')) {
//     $('.btn-teaser').parents('.card-body').addClass('btn-teaser-pb');
//   }
// });

// add darker background color to image container for better visibility
$(function() {
  if ($('.card-media-container').find('.img-dark-zoom')) {
    $('.img-dark-zoom').parents('.card-media-container').css('background-color', '#59514a');
  }
});

// box-shadow in same color as container
// $(function() {
//   $('.container-color-dark.box-shadow').addClass('box-shadow-dark');
// });
//
// $(function() {
//   $('.container-color-orange.box-shadow').addClass('box-shadow-orange');
// });